// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
import { LineGroup } from './GroupsImport';
import { UrlUtils } from '@shared/utils/UrlUtils';
export class NewsGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.NEWS_GROUP, null, pfixFieldSet);
    }
    getContent() {
        const text = this.getNormalizedText();
        const parsed = this.extractUrlFromText(text);
        if (parsed.hasText) {
            return text;
        }
        const line0 = this.getAllLines();
        if (isValidString(line0)) {
            return line0;
        }
        if (isValidString(parsed.url)) {
            return {
                isUrl: true,
                url: parsed.url
            };
        }
        return '';
    }
    getContentByLineNumber(lineNumber) {
        const groups = this.GetGroups(FieldsFactory.LINE_GROUP_NAME);
        for (const element of groups) {
            const line = new LineGroup(element);
            if (line.getLineNum() === lineNumber) {
                return line.getContent();
            }
        }
        return null;
    }
    getAllLines() {
        return LineGroup.getLongText(this);
    }
    getText() {
        return this.GetValue(FieldsFactory.FIELD_TEXT);
    }
    setText(text) {
        this.SetField(FieldsFactory.FIELD_TEXT, text);
    }
    getTheme() {
        return this.GetValue(FieldsFactory.FIELD_THEME);
    }
    setTheme(theme) {
        this.SetField(FieldsFactory.FIELD_THEME, theme);
    }
    getRouteID() {
        return this.GetValue(FieldsFactory.FIELD_ROUTE_ID);
    }
    setRouteID(routeID) {
        this.SetField(FieldsFactory.FIELD_ROUTE_ID, routeID);
    }
    getSource() {
        return this.GetValue(FieldsFactory.FIELD_SOURCE);
    }
    setSource(source) {
        this.SetField(FieldsFactory.FIELD_SOURCE, source);
    }
    getNewsID() {
        return this.GetValue(FieldsFactory.FIELD_NEWS_ID);
    }
    setNewsID(newsID) {
        this.SetField(FieldsFactory.FIELD_NEWS_ID, newsID);
    }
    getSymbol() {
        return this.GetValue(FieldsFactory.FIELD_SYMBOL);
    }
    setSymbol(symbol) {
        this.SetField(FieldsFactory.FIELD_SYMBOL, symbol);
    }
    getCategory() {
        return this.GetValue(FieldsFactory.FIELD_NEWS_CATEGORY);
    }
    setCategory(category) {
        this.SetField(FieldsFactory.FIELD_NEWS_CATEGORY, category);
    }
    getPriority() {
        return this.GetValue(FieldsFactory.FIELD_PRIORITY);
    }
    setPriority(priority) {
        this.SetField(FieldsFactory.FIELD_PRIORITY, priority);
    }
    getDate() {
        return this.GetValue(FieldsFactory.FIELD_DATE);
    }
    setDate(date) {
        this.SetField(FieldsFactory.FIELD_DATE, date);
    }
    getNormalizedText() {
        const text = this.getText();
        return isValidString(text) ? text.trim() : '';
    }
    extractUrlFromText(text) {
        var _a;
        if (!isValidString(text)) {
            return { hasText: false, url: null };
        }
        const urls = UrlUtils.ParseTextForURL(text, true);
        let hasText = false;
        let url = null;
        for (const item of urls) {
            if (((_a = item.value) === null || _a === void 0 ? void 0 : _a.length) <= 0) {
                continue;
            }
            if (item.isText === true) {
                hasText = true;
            }
            else {
                url = item.value;
            }
        }
        return { hasText, url };
    }
}
